var _rect, _circle, _circle2, _ellipse, _ellipse2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistribute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 64,
    fill: "#F8F9FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 32,
    fill: "#6741C6",
    fillOpacity: 0.1,
    stroke: "#6741C6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 8,
    fill: "#6741C6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 64,
    rx: 52,
    ry: 32,
    stroke: "#6741C6",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 64,
    rx: 32,
    ry: 52,
    stroke: "#6741C6",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 64,
    r: 6,
    fill: "#6741C6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 64,
    r: 6,
    fill: "#6741C6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 12,
    r: 6,
    fill: "#6741C6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 116,
    r: 6,
    fill: "#6741C6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 32,
    r: 5,
    fill: "#6741C6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 96,
    r: 5,
    fill: "#6741C6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 96,
    r: 5,
    fill: "#6741C6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 32,
    r: 5,
    fill: "#6741C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 64L112 64",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 72L64 112",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56 64L16 64",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64 56L64 16",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104 60L112 64L104 68",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104L64 112L68 104",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 68L16 64L24 60",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68 24L64 16L60 24",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistribute);
export default __webpack_public_path__ + "static/media/distribute.ed8e945a038b93a5f630c1bf56954b2d.svg";
export { ForwardRef as ReactComponent };